import { render, staticRenderFns } from "./ListarComarcas.vue?vue&type=template&id=228c2968&scoped=true"
import script from "./ListarComarcas.vue?vue&type=script&lang=js"
export * from "./ListarComarcas.vue?vue&type=script&lang=js"
import style0 from "./ListarComarcas.vue?vue&type=style&index=0&id=228c2968&lang=css"
import style1 from "./ListarComarcas.vue?vue&type=style&index=1&id=228c2968&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c2968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228c2968')) {
      api.createRecord('228c2968', component.options)
    } else {
      api.reload('228c2968', component.options)
    }
    module.hot.accept("./ListarComarcas.vue?vue&type=template&id=228c2968&scoped=true", function () {
      api.rerender('228c2968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ListarComarcas.vue"
export default component.exports